<lib-cdw-overlay [blur]="true" [size]="'medium'">
  <div class="empty-state-content">
    <div class="empty-state-text" [innerHTML]="htmlContent"></div>
    <img [src]="imageSource" alt="No items" class="empty-state-illustration" />
  </div>
</lib-cdw-overlay>
